class f extends HTMLElement {
  async connectedCallback() {
    if (this.initialized) return;
    if (
      ((this.initialized = !0),
      !this.podId || !this.listEl || !this.isTemplateReady)
    ) {
      this.clearTrackingAttributes(), this.hideSection();
      return;
    }
    const t = await this.waitForClient();
    if (!t) {
      this.clearTrackingAttributes(), this.hideSection();
      return;
    }
    try {
      const i = await t.recommendations.getRecommendations(
          this.podId,
          this.buildParameters(),
        ),
        s = this.mapProducts(i);
      if (s.length === 0) {
        this.clearTrackingAttributes(), this.hideSection();
        return;
      }
      this.renderProducts(s),
        this.setTrackingAttributes(i, s),
        this.showSection(),
        window.requestAnimationFrame(() => {
          this.initialiseLayout();
        });
    } catch (i) {
      console.error("Failed to load Constructor recommendations:", i),
        this.clearTrackingAttributes(),
        this.hideSection();
    }
  }
  buildParameters() {
    const t = Number.parseInt(this.dataset.limit, 10),
      i = {
        fmtOptions: {
          fields: ["id", "name", "url", "variation_id"],
        },
        section: this.dataset.section || "Products",
      };
    return (
      Number.isInteger(t) && t > 0 && (i.numResults = t),
      this.dataset.itemId && (i.itemIds = this.dataset.itemId),
      this.dataset.term && (i.term = this.dataset.term),
      i
    );
  }
  mapProducts(t) {
    const i = (t == null ? void 0 : t.response) || {},
      s = i.results || [];
    return s
      .map((e, a) => {
        var o, d, c, u, l, h, m, g, b;
        const r = (o = e == null ? void 0 : e.data) == null ? void 0 : o.url,
          n =
            ((d = e == null ? void 0 : e.data) == null ? void 0 : d.id) ||
            (e == null ? void 0 : e.value),
          p =
            ((c = e == null ? void 0 : e.data) == null ? void 0 : c.name) ||
            ((u = e == null ? void 0 : e.data) == null
              ? void 0
              : u.item_name) ||
            ((l = e == null ? void 0 : e.data) == null ? void 0 : l.title) ||
            "";
        return !r || !n
          ? null
          : {
              itemName: p,
              numResultsPerPage: s.length,
              podId:
                ((h = i == null ? void 0 : i.pod) == null ? void 0 : h.id) ||
                this.podId,
              productId: n,
              rawData: e.data,
              resultCount: s.length,
              resultPage: 1,
              resultPositionOnPage: a + 1,
              result_id: e.result_id,
              seedItemIds: this.seedItemIds,
              strategyId:
                ((m = e == null ? void 0 : e.strategy) == null
                  ? void 0
                  : m.id) || "",
              url: r,
              variationId:
                ((g = e == null ? void 0 : e.data) == null
                  ? void 0
                  : g.variation_id) ||
                ((b = e == null ? void 0 : e.data) == null
                  ? void 0
                  : b.variationId) ||
                "",
            };
      })
      .filter(Boolean);
  }
  renderProducts(t) {
    const i = t.length;
    (this.listEl.innerHTML = ""),
      t.forEach((s, e) => {
        const a = document.createElement(this.itemTagName);
        (a.className = this.itemClassName),
          this.slideElAttribute && a.setAttribute(...this.slideElAttribute),
          (this.layout === "carousel" || this.layout === "push-cart") &&
            (a.setAttribute("role", "group"),
            a.setAttribute("aria-label", this.getSlideAriaLabel(e + 1, i)));
        const r = this.createCard(s);
        r && (a.appendChild(r), this.listEl.appendChild(a));
      });
  }
  setTrackingAttributes(t, i) {
    var s, e, a;
    this.setAttribute("data-cnstrc-recommendations", ""),
      this.setTrackingAttribute(
        "data-cnstrc-recommendations-pod-id",
        ((s = i[0]) == null ? void 0 : s.podId) || this.podId,
      ),
      this.setTrackingAttribute(
        "data-cnstrc-result-id",
        ((e = t == null ? void 0 : t.response) == null
          ? void 0
          : e.result_id) || ((a = i[0]) == null ? void 0 : a.result_id),
      ),
      this.setTrackingAttribute(
        "data-cnstrc-recommendations-seed-items",
        this.seedItemIds.join(","),
      ),
      this.setAttribute("data-cnstrc-num-results", String(i.length));
  }
  clearTrackingAttributes() {
    this.removeAttribute("data-cnstrc-recommendations"),
      this.removeAttribute("data-cnstrc-recommendations-pod-id"),
      this.removeAttribute("data-cnstrc-result-id"),
      this.removeAttribute("data-cnstrc-recommendations-seed-items"),
      this.removeAttribute("data-cnstrc-num-results");
  }
  setTrackingAttribute(t, i) {
    if (!i) {
      this.removeAttribute(t);
      return;
    }
    this.setAttribute(t, i);
  }
  initialiseLayout() {
    if (!this.usesCarouselLayout) return;
    const t = this.carousel;
    if (!(!t || typeof t.setupCarousel != "function")) {
      if (t.carousel) {
        t.carousel.update();
        return;
      }
      t.carousel = t.setupCarousel();
    }
  }
  async waitForClient() {
    var t, i, s, e;
    for (let a = 0; a < 20; a += 1) {
      const r =
        ((i = (t = window.theme) == null ? void 0 : t.constructorIo) == null
          ? void 0
          : i.client) || null;
      if (r) return r;
      if (
        (e = (s = window.theme) == null ? void 0 : s.constructorIo) != null &&
        e.error
      )
        return null;
      await new Promise((n) => {
        window.setTimeout(n, 100);
      });
    }
    return null;
  }
  showSection() {
    this.container && (this.container.hidden = !1),
      this.setAssociatedTriggerHidden(!1),
      this.updateRootVisibility();
  }
  hideSection() {
    this.container && (this.container.hidden = !0),
      this.setAssociatedTriggerHidden(!0),
      this.activateFirstVisiblePanel(),
      this.updateRootVisibility();
  }
  get listEl() {
    return this.querySelector('[data-constructor-recommendations-el="items"]');
  }
  get podId() {
    var t;
    return ((t = this.dataset.podId) == null ? void 0 : t.trim()) || "";
  }
  get seedItemIds() {
    var i;
    const t = ((i = this.dataset.itemId) == null ? void 0 : i.trim()) || "";
    return t
      ? t
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
      : [];
  }
  get layout() {
    return this.dataset.layout || "grid";
  }
  get itemClassName() {
    return this.layout === "carousel"
      ? "sec-ProductCarousel_Slide keen-slider__slide"
      : this.layout === "push-cart"
        ? "psh-Recommendations_Slide keen-slider__slide"
        : "sec-Recommendations_Item prd-List_Item";
  }
  get itemTagName() {
    return this.usesCarouselLayout ? "div" : "li";
  }
  // Returns [attributeName, attributeValue] to stamp on each slide item, or null.
  get slideElAttribute() {
    return this.layout === "carousel"
      ? ["data-product-carousel-el", "slide"]
      : this.layout === "push-cart"
        ? ["data-push-cart-carousel-el", "slide"]
        : null;
  }
  get container() {
    return this.closest("[data-constructor-recommendations-section]");
  }
  get root() {
    return (
      this.closest("[data-constructor-recommendations-root]") || this.container
    );
  }
  get panelIndex() {
    var t;
    return ((t = this.container) == null ? void 0 : t.dataset.index) || "";
  }
  get tabsRoot() {
    return this.closest("product-carousel-tabs");
  }
  get trigger() {
    return !this.tabsRoot || !this.panelIndex
      ? null
      : this.tabsRoot.querySelector(
          `[data-product-carousel-tabs-el="trigger"][data-index="${this.panelIndex}"]`,
        );
  }
  get tabsTriggers() {
    return this.tabsRoot
      ? Array.from(
          this.tabsRoot.querySelectorAll(
            '[data-product-carousel-tabs-el="trigger"]',
          ),
        )
      : [];
  }
  get tabsPanels() {
    return this.tabsRoot
      ? Array.from(
          this.tabsRoot.querySelectorAll(
            '[data-product-carousel-tabs-el="panel"]',
          ),
        )
      : [];
  }
  get templateProductCard() {
    return document.getElementById("templateProductCard");
  }
  get isTemplateReady() {
    return this.layout === "push-cart" ? !0 : !!this.templateProductCard;
  }
  get usesCarouselLayout() {
    return this.layout === "carousel" || this.layout === "push-cart";
  }
  get carousel() {
    return this.closest("product-carousel, push-cart-carousel");
  }
  createCard(t) {
    if (this.layout === "push-cart") {
      const e = document.createElement("push-cart-product-card");
      return e.setAttribute("data-prop-data", JSON.stringify(t)), e;
    }
    const i = document.importNode(this.templateProductCard.content, !0),
      s = i.querySelector("product-card");
    return s ? (s.setAttribute("data-prop-data", JSON.stringify(t)), i) : null;
  }
  getSlideAriaLabel(t, i) {
    return `slide ${t} of ${i}`;
  }
  setAssociatedTriggerHidden(t) {
    this.layout !== "carousel" || !this.trigger || (this.trigger.hidden = t);
  }
  activateFirstVisiblePanel() {
    if (this.layout !== "carousel" || !this.tabsRoot) return;
    const t = this.tabsTriggers.filter((r) => !r.hidden),
      i = this.tabsPanels.filter((r) => !r.hidden);
    if (t.length === 0 || i.length === 0) return;
    const s = t.some((r) => r.getAttribute("aria-selected") === "true"),
      e = i.some((r) => r.getAttribute("aria-hidden") === "false");
    if (s && e) return;
    const a = t[0].dataset.index;
    this.tabsTriggers.forEach((r) => {
      const n = !r.hidden && r.dataset.index === a;
      r.setAttribute("aria-selected", String(n)),
        r.setAttribute("aria-pressed", String(n));
    }),
      this.tabsPanels.forEach((r) => {
        r.setAttribute(
          "aria-hidden",
          String(r.hidden || r.dataset.index !== a),
        );
      });
  }
  updateRootVisibility() {
    if (this.layout !== "carousel" || !this.root) return;
    const t = this.tabsPanels.some((i) => !i.hidden);
    this.root.hidden = !t;
  }
}
window.customElements.get("constructor-recommendations") ||
  window.customElements.define("constructor-recommendations", f);
